import React, { Component } from 'react';
import classes from './UpdateNotification.module.scss';
import globalJson from '../../../data/global.json';
import { getFileName } from '../../../helpers/FileCaching';
import ServiceWorkerNotifications from 'helpers/ServiceWorkerNotifications'

const globalImages = require.context('../../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);

class UpdateNotification extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hasUpdates:false
        }

        let self = this;
        ServiceWorkerNotifications.registerCallback(this.onNewContent.bind(this))
    }
    onNewContent(event){
        console.log(event)
        this.setState({
            hasUpdates:true
        })
        navigator.serviceWorker.getRegistration().then(function(reg){
            //reg.update();
        })
    }
    reloadPage(){
        if ('serviceWorker' in navigator) {
            window.location.reload();
        }
    }

    render() {
        let button = "";

        if(this.state.hasUpdates) {
            button = 
                <div 
                    className={classes['background']} 
                    >
                    <img className={classes['opt-in-msg']}
                        src={getFileName(globalImages, 'update-bar.svg')}
                    />
                </div>
            {return (
                <div className={classes['notification-opt']}>
                    { button }
                </div>
            )}
        }

        return (
            <div>
            </div>
        )
    }
}

export default UpdateNotification;